<template>
  <div class="my-3 py-2 container-fluid">
    <div class="card mb-4">
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
          <table class="table align-items-center mb-4">
            <thead class="head-color-ligh-gray">
              <tr>
                <th
                  class="text-uppercase text-default text-xxs font-weight-bolder opacity-7"
                >
                  {{ $t("parents.name") }}
                </th>
                <th
                  class="text-center text-uppercase text-default text-xxs font-weight-bolder opacity-7"
                >
                  {{ $t("payments.paymentDate") }}
                </th>
                <th
                  class="text-center text-uppercase text-default text-xxs font-weight-bolder opacity-7"
                >
                  {{ $t("payments.amount") }}
                </th>
                <th
                  class="text-center text-uppercase text-default text-xxs font-weight-bolder opacity-7"
                >
                  {{ $t("teachers.details") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in payments" :key="item.id">
                <td>
                  <div class="d-flex px-2 py-1">
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-0 text-sm">
                        {{ item.parent.parent_name }}
                      </h6>
                    </div>
                  </div>
                </td>
                <td class="align-middle text-center">
                  <span class="text-secondary text-xs font-weight-bold">
                    {{ item.date }}</span
                  >
                </td>
                <td class="align-middle text-center">
                  <span class="text-secondary text-xs font-weight-bold">
                    {{ item.paid_amount }} {{ $t("global.currency") }}
                  </span>
                </td>
                <td class="align-middle text-center text-sm">
                  <a href="#" @click="showCourse(item)">
                    <soft-badge color="success" variant="gradient" size="sm">
                      {{ $t("teachers.details") }}
                    </soft-badge>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <soft-pagination color="success" size="sm">
      <soft-pagination-item
        prev
        @click="prevPage"
        :disabled="currentPage === 1"
      />
      <div v-for="item in totalPages" :key="item">
        <soft-pagination-item
          v-if="item == currentPage"
          :label="currentPage"
          active
        />
        <soft-pagination-item
          v-if="item != currentPage"
          :label="item"
          @click="currPage(item)"
        />
      </div>
      <soft-pagination-item
        next
        @click="nextPage"
        :disabled="currentPage === totalPages"
      />
    </soft-pagination>
  </div>
</template>

<script>
import axios from "axios";
import SoftPagination from "@/components/SoftPagination.vue";
import SoftPaginationItem from "@/components/SoftPaginationItem.vue";
import SoftBadge from "@/components/SoftBadge.vue";

export default {
  name: "payments",
  components: {
    SoftPagination,
    SoftPaginationItem,
    SoftBadge,
  },
  data() {
    return {
      payments: [],
      isCreateCourseVisible: false,
      currentPage: 1,
      totalPages: 1,
    };
  },
  created() {
    this.getPayments();
  },
  methods: {
    async getPayments(page = 1) {
      let response = await axios.get(`payments?page=${page}`);
      this.payments = response.data.payments;
      this.currentPage = response.data.meta.current_page;
      this.totalPages = response.data.meta.last_page;
    },
    showCreateForm() {
      this.isCreateCourseVisible = true;
    },
    hideChild() {
      this.isCreateCourseVisible = false;
    },
    courseCreated() {
      this.isCreateCourseVisible = false;
      this.getCourses();
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getPayments(this.currentPage);
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getPayments(this.currentPage);
      }
    },
    currPage(item) {
      this.currentPage = item;
      this.getPayments(item);
    },
  },
};
</script>

<style scoped>
.head-color-ligh-gray {
  background-color: #82d616;
  box-shadow: 2px 2px 8px 2px;
}
</style>
